import { render, staticRenderFns } from "./WidgetBoolean.vue?vue&type=template&id=575f248a&scoped=true&lang=pug"
import script from "./WidgetBoolean.vue?vue&type=script&lang=js"
export * from "./WidgetBoolean.vue?vue&type=script&lang=js"
import style0 from "./WidgetBoolean.vue?vue&type=style&index=0&id=575f248a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575f248a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCol,VIcon,VInput,VRow})
